import type { UserFriendlyError } from "../types";
import { getSiteTextFallbackContent } from "@Front/Stores/defaultSiteTextFallbacks";
import { SiteTextsStore } from "@Front/Stores/SiteTextsStore";
import { SITE_TEXTS_BOOT_LOCALE } from "@Front/Stores/siteTextsBootConfig";

export type LoginSiteTextUserFriendlyKeysInput = {
	titleKey: string;
	bodyKey: string;
	staticTitle: string;
	staticMessage: string;
	canRetry: boolean;
};

/**
 * Construit un `UserFriendlyError` à partir de deux clés `site_texts` (scope login),
 * avec repli sur les fallbacks front puis sur les chaînes statiques.
 */
export function resolveUserFriendlyFromLoginSiteTextKeys(input: LoginSiteTextUserFriendlyKeysInput): UserFriendlyError {
	const { titleKey, bodyKey, staticTitle, staticMessage, canRetry } = input;
	const locale = SITE_TEXTS_BOOT_LOCALE;
	const titleRaw = SiteTextsStore.instance.getContent(titleKey, locale).trim();
	const bodyRaw = SiteTextsStore.instance.getContent(bodyKey, locale).trim();
	const title = titleRaw || getSiteTextFallbackContent(titleKey, locale) || staticTitle;
	const message = bodyRaw || getSiteTextFallbackContent(bodyKey, locale) || staticMessage;
	return { title, message, canRetry };
}

/** Jeton / session (aligné `SITE_TEXTS_KEYS_INDEX` : `login.modal.sessionExpired.*`). */
export function getLoginSessionExpiredUserFriendlyError(): UserFriendlyError {
	return resolveUserFriendlyFromLoginSiteTextKeys({
		titleKey: "login.modal.sessionExpired.title",
		bodyKey: "login.modal.sessionExpired.body",
		staticTitle: "Session expirée",
		staticMessage: "Votre session a expiré ou a été révoquée. Veuillez vous reconnecter.",
		canRetry: false,
	});
}

/** Réponse HTTP 401 sans message métier plus précis (`login.error.http401.*`). */
export function getLoginHttp401UnauthorizedUserFriendlyError(): UserFriendlyError {
	return resolveUserFriendlyFromLoginSiteTextKeys({
		titleKey: "login.error.http401.title",
		bodyKey: "login.error.http401.body",
		staticTitle: "Accès refusé",
		staticMessage:
			"Vous n'avez pas les droits nécessaires pour effectuer cette action. Vérifiez vos permissions ou contactez votre administrateur.",
		canRetry: false,
	});
}
